import { getBiLogger } from '../../utils/biLogger';

export const getPaymentArraysFromMethods = (methods) => {
  const paymentCategory = [];
  const paymentProvider = [];

  if (methods) {
    methods.forEach((paymentMethod) => {
      paymentCategory.push(paymentMethod.value || paymentMethod.paymentMethod);
      paymentProvider.push(paymentMethod.connectedProviderId);
    });
  }

  return {
    paymentCategory,
    paymentProvider,
  };
};

export const logCheckOutNoAvailableProvidersRefreshClicked = (result) => {
  let refreshResult = false;
  if (result && result.paymentMethods) {
    refreshResult = result.paymentMethods.some(
      (paymentMethod) => !paymentMethod.disabled
    );
  }
  const { paymentCategory, paymentProvider } = getPaymentArraysFromMethods(
    result && result.paymentMethods
  );

  getBiLogger().checkOutNoAvailableProvidersRefreshClicked({
    refreshResult,
    paymentCategory: paymentCategory.join(','),
    paymentProvider: paymentProvider.join(','),
  });
};
